import React from "react";
import { Link } from "gatsby";

const Clients = ({ clients }) => {
  clients.sort((a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }

    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }

    return 0;
  });

  //

  const aToZ = {};

  clients.forEach(client => {
    const firstLetter = client.name[0];

    if (!aToZ[firstLetter]?.[0]) {
      aToZ[firstLetter] = [client];
    } else {
      aToZ[firstLetter].push(client);
    }
  });

  const aToZKeys = Object.keys(aToZ);

  return (
    <ul className="grid text-orange">
      {aToZKeys.map((char, index) => {
        const key = `${char}-${index}`;
        const keyedClients = aToZ[char];

        return (
          <li
            key={key}
            className="animation-appear-down animation-delay-5 w-full grid-end-6 xs:grid-end-8 relative pb-v4 xs:pb-v8 xs:mt-v4 flex justify-between xs:justify-start"
          >
            <div className="w-2/6 xs:w-1/4 b1 universal-sans xs:mt-v0 xs:mb-v0">
              {char}
            </div>

            <ul className="w-4/6 xs:w-3/4 relative">
              {keyedClients.map(client => {
                return (
                  <li
                    key={client.name}
                    className="clients-page__item relative flex justify-between b1 universal-sans"
                  >
                    {(client?.link && (
                      <Link
                        to={client.link}
                        className="hover-underline text-orange"
                      >
                        {client.name}
                      </Link>
                    )) || (
                      <span className="text-orange" style={{ opacity: `0.4` }}>
                        {client.name}
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};

export default Clients;
